import { Kana, NotIncludeCsvSeparator, NumberIdentity, Version, } from "@ascend-ltd/logic-helpers";
import { z } from "zod/v4";
const SegmentIdSchema = NumberIdentity.schema.brand();
export const SegmentId = {
    schema: SegmentIdSchema,
};
const SegmentNameSchema = z
    .object({
    name: NotIncludeCsvSeparator.schema.and(z.string().min(1).max(32)),
    kana: Kana.schema.and(z.string().min(1).max(32)),
})
    .brand();
const SegmentEntitySchema = z.object({
    id: SegmentId.schema,
    name: SegmentNameSchema,
    version: Version.schema,
});
const create = (args) => {
    const values = {
        id: NumberIdentity.generate(),
        version: Version.initial(),
        ...args,
    };
    return SegmentEntity.schema.parse(values);
};
const update = (entity, args) => {
    const next = {
        ...entity,
        ...args,
    };
    return SegmentEntity.schema.parse(next);
};
export const SegmentEntity = {
    schema: SegmentEntitySchema,
    reconstruct: (args) => SegmentEntity.schema.parse(args),
    create,
    update,
};
//# sourceMappingURL=segment-entity.js.map